const Sidebar = props => {
	return <></>;
};

export default Sidebar;
